/* oxlint-disable no-console -- local Liveblocks auth diagnostics */

import { type AxiosInstance, isAxiosError } from 'axios'

export interface LiveblocksAuthToken {
  token: string
}

export interface LiveblocksAuthForbidden {
  error: 'forbidden'
  reason: string
}

export type LiveblocksAuthResult = LiveblocksAuthToken | LiveblocksAuthForbidden

// Liveblocks wraps `authEndpoint` in a 10s timer and retries any thrown error
// with backoff. 401/403 after `refreshIfExpired` will not succeed on retry, so
// return `{ error: 'forbidden' }` to StopRetrying:
// https://liveblocks.io/docs/api-reference/liveblocks-client#createClientCallback
export async function authorizeLiveblocksSession(
  seenApi: Pick<AxiosInstance, 'post'>,
  options?: { roomId?: string }
): Promise<LiveblocksAuthResult> {
  try {
    const { data } = await seenApi.post<LiveblocksAuthToken>(
      '/liveblocks-auth',
      {}
    )
    return data
  } catch (error) {
    if (
      isAxiosError(error) &&
      (error.response?.status === 401 || error.response?.status === 403)
    ) {
      console.info(
        '[Liveblocks] stopping connection retries after unauthorized /liveblocks-auth',
        { status: error.response.status, roomId: options?.roomId }
      )
      return { error: 'forbidden', reason: 'Unauthorized' }
    }
    throw error
  }
}
